import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getSelection, $isRangeSelection, COMMAND_PRIORITY_CRITICAL, COPY_COMMAND } from "lexical";
import { useEffect } from "react";

const ClipboardHandlerPlugin = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        // Block copy of signature block node and clear clipboard
        const removeCopyListener = editor.registerCommand(
            COPY_COMMAND,
            (event: ClipboardEvent) => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    const nodes = selection.getNodes();
                    const containsSignatureBlock = nodes.some((node) => node.getType() === "signature-block");
                    if (containsSignatureBlock) {
                        event.preventDefault();
                        // Clear the clipboard
                        if (event.clipboardData) {
                            event.clipboardData.setData("text/plain", "");
                            event.clipboardData.setData("text/html", "");
                        }
                        return true;
                    }
                }
                return false;
            },
            COMMAND_PRIORITY_CRITICAL,
        );

        return () => {
            removeCopyListener();
        };
    }, [editor]);

    return null;
};

export default ClipboardHandlerPlugin;
